import {
    IDeleteTicketAttachmentsAction,
    IDeleteTicketAttachmentsErrorAction,
    IDeleteTicketAttachmentsSuccessAction
} from '../actions/delete-ticket-attachments';
import { ITicketsState } from '../state';
import { initialState } from './initial-state';
import { createAsyncReducer } from '../../standard-actions/reducers';

export type TicketsAction
    = IDeleteTicketAttachmentsAction
    | IDeleteTicketAttachmentsSuccessAction
    | IDeleteTicketAttachmentsErrorAction;

const init = (state: ITicketsState, action: TicketsAction) => ({
    ...state,
    deleteAttachments: {
        ...initialState.deleteAttachments,
        status: action.status,
    }
});

const success = (state: ITicketsState, action: TicketsAction) => ({
    ...state,
    deleteAttachments: {
        ...initialState.deleteAttachments,
        status: action.status,
        data: (action as IDeleteTicketAttachmentsSuccessAction).data
    }
});

const failure = (state: ITicketsState, action: TicketsAction) => ({
    ...state,
    deleteAttachments: {
        ...initialState.deleteAttachments,
        status: action.status,
        error: (action as IDeleteTicketAttachmentsErrorAction).error,
        code: (action as IDeleteTicketAttachmentsErrorAction).code
    }
});

const reset = (state: ITicketsState, action: TicketsAction) => ({
    ...state,
    deleteAttachments: {
        ...initialState.deleteAttachments,
        status: action.status,
    }
});

export const deleteAttachmentsReducer = createAsyncReducer(initialState, init, success, failure, reset);
